import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import VocabularyView from './vocabulary-view';
import { EditProps } from './vocabulary.constants';

const VocabularyEdit = (props: EditProps) => {
  const { openDrawer } = useActivityBuilderContext();

  return (
    <>
      {props.vocabularyDefinitions &&
      props.vocabularyDefinitions?.length > 0 ? (
        <VocabularyView {...props} includeToggle={false} />
      ) : (
        <ComponentEmptyButton
          onClick={() => openDrawer({ componentId: props.id })}
          buttonText="Add Vocabulary"
          isSmall
        />
      )}
    </>
  );
};

export default VocabularyEdit;
